import PinSvgIcon from "../Svg/PinSvgIcon";
import PlusIconSvg from "../Svg/PlusIconSvg";
import CloseSvgIcon from "../Svg/CloseSvgIcon";
import AlertContext from "../context/AlertContext";
import React, { useState, useRef, useContext } from "react";
import CreateSchemaTableHooks from "../Hooks/CreateSchemaTableHooks";

export default function UploadButton() {
  const Alert = useContext(AlertContext);

  const CreateSchemaTableHks = CreateSchemaTableHooks();

  const fileInputRef = useRef(null);

  const [fileName, setFileName] = useState(null);

  const handleFileChange = (event) => {
    const file = event.target.files?.[0];

    if (file) {
      const validExtensions = ["yaml", "yml", "sql"];
      const fileExtension = file.name.split(".").pop().toLowerCase();

      if (!validExtensions.includes(fileExtension)) {
        Alert.setShowNotify({
          show: true,
          title: "Error",
          msg: "Invalid file type. Please upload a valid SQL file (.sql).",
        });
        return;
      }

      setFileName(file.name);

      const reader = new FileReader();

      reader.onload = (e) => {
        const sqlContent = e.target.result;
        const parsedTables = CreateSchemaTableHks.parseCreateTable(sqlContent);

        Alert.setTestDetail((prev) => ({
          ...prev,
          dbSchema: sqlContent,
          schema: parsedTables,
        }));
      };

      reader.readAsText(file);
    }
  };

  const removeFile = () => {
    setFileName(null);
    Alert.setTestDetail((prev) => {
      const { schema, ...rest } = prev;

      return rest;
    });
  };

  return fileName ? (
    <div className="uploadedFile">
      <PinSvgIcon active={true} /> {fileName}
      <CloseSvgIcon component={"sql"} onClick={removeFile} />
    </div>
  ) : (
    <button type="button" className="uploadButton">
      <span className="icon">
        <PlusIconSvg type={2} />
      </span>
      <span className="buttonLabel">Attach Schema</span>
      <input
        type="file"
        ref={fileInputRef}
        className="fileInput"
        accept=".yaml,.yml,.sql"
        onChange={handleFileChange}
      />
    </button>
  );
}
